import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { FormControl, ReactiveFormsModule } from "@angular/forms";
import { Observable, of } from "rxjs";
import { debounceTime, distinctUntilChanged, switchMap, filter, startWith, tap } from "rxjs/operators";

import {
	MatLegacyAutocompleteModule as MatAutocompleteModule,
	MatLegacyAutocompleteSelectedEvent as MatAutocompleteSelectedEvent
} from "@angular/material/legacy-autocomplete";
import { MatLegacyInputModule as MatInputModule } from "@angular/material/legacy-input";
import { MatLegacyFormFieldModule as MatFormFieldModule } from "@angular/material/legacy-form-field";
import { AsyncPipe, JsonPipe, NgFor, NgIf } from "@angular/common";
import { MatLegacyProgressSpinnerModule as MatProgressSpinnerModule } from "@angular/material/legacy-progress-spinner";
import { IconModule } from "@shared/components/icon/icon.module";

const MINIMAL_PRESS_SIGNS = 1;

@Component({
	selector: "app-search-autocomplete",
	standalone: true,
	imports: [
		ReactiveFormsModule,
		AsyncPipe,
		NgFor,
		NgIf,
		JsonPipe,
		MatAutocompleteModule,
		MatInputModule,
		MatFormFieldModule,
		MatProgressSpinnerModule,
		IconModule
	],
	templateUrl: "./search-autocomplete.component.html",
	exportAs: "matAutocomplete"
})
export class SearchAutocompleteComponent<T> implements OnInit {
	@Input() label: string = "Search";
	@Input({ required: true }) searchFn!: (query: string) => Observable<T[]>;
	@Input({ required: true }) displayWith!: (item: T) => string;
	@Output() selectionChanged = new EventEmitter<T>();

	searchControl = new FormControl("", { nonNullable: true });
	filteredOptions$!: Observable<any>;
	isLoading = false;

	ngOnInit(): void {
		this.filteredOptions$ = this.searchControl.valueChanges.pipe(
			startWith(this.searchControl.value),
			filter((value): value is string => value != null && value.length > 0),
			debounceTime(300),
			distinctUntilChanged(),
			tap(() => (this.isLoading = true)),
			switchMap((query: string) => {
				const isString = typeof query === "string";
				if (isString && query.length >= MINIMAL_PRESS_SIGNS) {
					return this.searchFn(query);
				} else {
					return of([]);
				}
			}),
			tap(() => (this.isLoading = false))
		);
	}

	onOptionSelected(event: MatAutocompleteSelectedEvent): void {
		this.selectionChanged.emit(event.option.value as T);
	}
}
